import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  type: 'info', //takes value success, error, info, warning
};

const snackbarSlice = createSlice({
  name: 'snackbarSlice',
  initialState,
  reducers: {
    setSnackbarState: (state, action) => {
      const { open, message, type } = action?.payload;
      state.open = open;
      state.message = message;
      state.type = type;
    },
  },
});

export const { setSnackbarState } = snackbarSlice.actions;
export default snackbarSlice.reducer;
